// MasonryImageList.tsx
import * as React from 'react';
import { Grid, Box, ImageList, ImageListItem, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useTranslation } from 'react-i18next';
import { GalleryImage } from '../types/galleryImage';
import { CallbackFunction } from '../types/callback';
import { LightShotSingle } from '../components/LightShotSingle';
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import Share from "yet-another-react-lightbox/plugins/share";
import Inline from "yet-another-react-lightbox/plugins/inline";
import Counter from "yet-another-react-lightbox/plugins/counter";
import { displayErrorToast } from '../utils/toasts';
import { cookies } from '../cookies';

const inline = {
    style: {
        width: "100%",
        aspectRatio: "3 / 2",
        margin: "0 auto",
    },
};

export default function MasonryImageList({ images, clickBack }: { images: GalleryImage[] | undefined, clickBack: CallbackFunction }) {
    const { t } = useTranslation();
    const [open, setOpenLightShot] = React.useState(false);
    const [selectedImage, setSelectedImage] = React.useState<GalleryImage>();

    const handleOpenLightShot = (item: GalleryImage) => {
        setSelectedImage(item);
        setOpenLightShot(true);
    }

    if(!navigator.canShare && cookies.get('webshare.error') === undefined) {
        cookies.set('webshare.error', 'true', { maxAge: 3600 });
        displayErrorToast("Note: your current browser does not support the Web Share API");
    }

    return (
        <Box>
            <Box sx={{ height: '120px' }} />
            <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginRight: '20px',
                  }} >
                <Grid container direction="row" spacing={2}>
                    <ArrowBackIosNewIcon onClick={clickBack} sx={{ '&:hover': { cursor: 'pointer' }}} />
                    <Typography  onClick={clickBack} sx={{ '&:hover': { cursor: 'pointer' }}} >
                        {t("button.back")}
                    </Typography>
                </Grid>
            </Box>
            <Box sx={{ p: '20px' }}>
                <Lightbox
                    slides={images}
                    inline={inline}
                    counter={{ container: { style: { top: "unset", bottom: 0 } } }}
                    plugins={[Fullscreen, Zoom, Download, Share, Inline, Counter]} />
            {/*
                <ImageList key="masonry" variant="masonry" cols={3} gap={8}>
                    {images !== undefined && images.map((item: GalleryImage) => (
                        <Box>
                            <ImageListItem key={item.name} onClick={() => handleOpenLightShot(item)}>
                                <img srcSet={item.src}
                                     src={item.src}
                                     alt={item.name}
                                     loading="lazy" />
                            </ImageListItem>
                        </Box>
                    ))}
                </ImageList>
                <LightShotSingle image={selectedImage} opened={open} setOpenLightShot={setOpenLightShot} />
                */}
            </Box>
            <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginRight: '20px',
                    marginBottom: '40px'
                  }} >
                <Grid container direction="row" spacing={2}>
                    <ArrowBackIosNewIcon onClick={clickBack} sx={{ '&:hover': { cursor: 'pointer' }}} />
                    <Typography  onClick={clickBack} sx={{ '&:hover': { cursor: 'pointer' }}} >
                        {t("button.back")}
                    </Typography>
                </Grid>
            </Box>
        </Box>
    );
}